<template>
  <div class="contact-view container py-5">
    <div class="text-center mb-5">
      <h2 class="fw-bold text-gold">Contact Us</h2>
      <p class="text-muted">
        We welcome your questions, blessings, and feedback.
      </p>
    </div>

    <div class="row g-5 align-items-start">
      <!-- Contact Info -->
      <div class="col-12 col-md-5">
        <div class="bg-light rounded p-4 shadow-sm contact-info">
          <h5 class="text-gold fw-bold mb-3">Temple Information</h5>
          <p class="mb-2">
            <i class="bi bi-geo-alt-fill me-2 text-gold"></i>
            Sri Sambuddha Viharaya, Kandy, Sri Lanka
          </p>
          <p class="mb-2">
            <i class="bi bi-telephone-fill me-2 text-gold"></i>
            +94 81 234 5678
          </p>
          <p class="mb-2">
            <i class="bi bi-envelope-fill me-2 text-gold"></i>
            info@srisambuddha.lk
          </p>

          <div class="mt-4">
            <h6 class="text-gold fw-bold">Visiting Hours</h6>
            <p class="mb-0">Monday – Sunday: 6:00 AM – 8:00 PM</p>
          </div>
        </div>

        <div class="map-container mt-4 shadow-sm rounded overflow-hidden">
          <iframe
            src="https://www.google.com/maps?q=kandy%20temple%20sri%20lanka&output=embed"
            width="100%"
            height="250"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>

      <!-- Contact Form -->
      <div class="col-12 col-md-7">
        <form class="bg-light p-4 rounded shadow-sm contact-form">
          <div class="mb-3">
            <label class="form-label fw-bold">Full Name</label>
            <input type="text" class="form-control" placeholder="Your name" />
          </div>
          <div class="mb-3">
            <label class="form-label fw-bold">Email</label>
            <input
              type="email"
              class="form-control"
              placeholder="your@email.com"
            />
          </div>
          <div class="mb-3">
            <label class="form-label fw-bold">Message</label>
            <textarea
              class="form-control"
              rows="4"
              placeholder="Your message..."
            ></textarea>
          </div>
          <button type="submit" class="btn btn-gold px-4 w-100 w-md-auto">
            <i class="bi bi-send me-1"></i> Send Message
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.text-gold {
  color: #c69f59;
}

.btn-gold {
  background-color: #f6d57a;
  color: #4a3200;
  border: none;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.btn-gold:hover {
  background-color: #ffeaa7;
  color: #3a2700;
}

/* Map styling */
.map-container iframe {
  border-radius: 8px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .contact-view {
    padding: 2rem 1rem !important;
  }

  .contact-info,
  .contact-form {
    padding: 1.5rem !important;
  }

  .contact-form button {
    width: 100% !important;
  }

  .map-container iframe {
    height: 200px !important;
  }

  h2 {
    font-size: 1.75rem;
  }

  .text-muted {
    font-size: 0.95rem;
  }
}

@media (max-width: 576px) {
  .contact-view {
    padding: 1.5rem 0.5rem !important;
  }

  h2 {
    font-size: 1.5rem;
  }

  .contact-info p,
  .contact-form label {
    font-size: 0.9rem;
  }
}
</style>
